/**************************************************
 * Nombre:       Home_Frase
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import logo from '../../../Recursos/logo_oscuro.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Frase = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', borderRight: sCell ? 0 : 1, borderColor: '#00000050'}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: 42,
                                fontWeight: 600,
                                color: theme.palette.primary.main,
                                pr: sCell ? 0 : 8,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'right',
                            }}>
                                Hospitalidad, comodidad y tradición en el corazón de Tumaco.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', pl: sCell ? 0 : 8, mt: sCell ? 4 : 0}}>
                            <img src={logo} width={160} height={'auto'}/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Frase